import { useCurrentUserContext } from '../providers/current-user-provider.js';

const useCurrentUser = () => {
  const context = useCurrentUserContext();
  return context.currentUser;
};

export { useCurrentUser as default };
